export default __webpack_public_path__ + "static/media/payment-success.5b1f9dcb.svg";